<template>
  <div>
    <div
      class="cont"
      :class="item.member_info.is_read ? 'anse' : ''"
      v-for="(item, index) in list"
      @click="jump(item.member_info.member_id, index)"
    >
      <!-- <div class="iconfont icon-close close" v-if="type == 1"></div> -->
      <div class="kuang" :class="item.select ? 'on' : ''" v-show="type == 1">
        <div class="iconfont icon-right" v-show="item.select"></div>
      </div>
      <div class="contLeft">
        <div class="imgBox">
          <div class="img">
            <img
              :src="
                item.member_info.avatars != '/static/avatar/man.png'
                  ? $imgUrl + item.member_info.avatars
                  : item.member_info.sex_cn == '男'
                  ? 'https://www.yhrl.com/static/avatar/man.png'
                  : 'https://www.yhrl.com/static/avatar/woman.png'
              "
              alt=""
            />
          </div>
          <div class="money dis-cent" v-if="item.member_info.member_job">
            <span
              v-if="
                item.member_info.member_job[0].minprice == 0 &&
                item.member_info.member_job[0].maxprice == 0
              "
              >面议</span
            >
            <span v-else>
              {{ item.member_info.member_job[0].minprice }}k-{{
                item.member_info.member_job[0].maxprice
              }}k
            </span>
          </div>
        </div>
      </div>
      <div class="contRit">
        <div class="name" v-if="item.member_info.realname">
          {{
            daysNum > 0
              ? item.member_info.realname
              : "NO." + item.member_info.member_id
          }}<span v-if="daysNum > 0"> · {{ item.member_info.phone }}</span>
          <span style="margin-left: 15px" v-if="item.member_info.is_interview"
            >[已预约过面试]</span
          >
        </div>
        <div class="name" v-if="!item.member_info.realname">
          {{ "NO." + item.member_id
          }}<span v-if="daysNum > 0">
            ·
            {{
              item.member_info.phone ? item.member_info.phone : "暂无联系方式"
            }}</span
          >
          <span style="margin-left: 15px" v-if="item.member_info.is_interview"
            >[已预约过面试]</span
          >
        </div>
        <div class="txtBox">
          <div class="txt">{{ item.member_info.sex_cn }}</div>
          <div class="shu"></div>
          <div class="txt" v-if="item.age != 2024">{{ item.age }}岁</div>
          <div class="txt" v-if="item.age == 2024">未填写</div>
          <div class="shu"></div>
          <div class="txt">
            {{
              item.member_info.experience_cn
                ? item.member_info.experience_cn
                : "未填写"
            }}
          </div>
          <div class="shu"></div>
          <div class="txt">
            {{
              item.member_info.current_cn
                ? item.member_info.current_cn
                : "未填写"
            }}
          </div>
          <div class="shu"></div>
        </div>
        <div class="textBox">
          <div class="txt">期望:</div>
          <div class="text c-1" v-if="item.member_info.member_job">
            {{ item.member_info.member_job_txt }}
          </div>
        </div>
        <div class="textBox">
          <div class="txt">优势:</div>
          <div class="text c-1">
            {{
              item.member_info.speciality
                ? item.member_info.speciality
                : "暂未填写优势"
            }}
          </div>
        </div>
        <!-- <div class="textBox">
              <div class="txt1">最新登录时间:</div>
              <div class="text1">{{ item.login_time }}</div>
            </div> -->
        <div class="textBox">
          <div class="txt1">求职更新时间:</div>
          <div class="text1">{{ item.gxtime }}</div>
        </div>
        <div class="typeBox">
          <div
            class="txt"
            v-if="item.member_info.education_cn"
            :class="item.member_info.is_read ? 'anse' : ''"
          >
            {{ item.member_info.education_cn }}
          </div>
          <template v-if="item.member_info.member_job">
            <template v-if="item.member_info.member_job[0].district_cn1">
              <div
                class="txt"
                :class="item.member_info.is_read ? 'anse' : ''"
                v-for="itemq in item.member_info.member_job[0].district_cn1"
              >
                {{ itemq }}
              </div>
            </template>
            <template v-else>
              <div class="txt" :class="item.member_info.is_read ? 'anse' : ''">
                {{ item.member_info.member_job[0].district_cn }}
              </div>
            </template>
          </template>
        </div>
      </div>
      <div class="contJl">
        <div class="lcLi" v-if="item.member_info.member_experience">
          <div class="iconBox">
            <div class="icon">
              <div class="iconfont icon--_liepinqiuzhi liepinqiuzhi"></div>
            </div>
            <div class="shu"></div>
          </div>
          <div class="boxs">
            <div class="box" v-for="job in item.member_info.member_experience">
              <div class="time">
                {{ job.start_time ? job.start_time : "未填写" }} -
                {{ job.end_time ? job.end_time : "未填写" }}
              </div>
              <div class="textBox">
                <div class="text">{{ job.companyname }}</div>
                <div class="yuan"></div>
                <div class="text">{{ job.jobs }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="lcLi" v-if="item.member_info.member_education.id != 0">
          <div class="iconBox">
            <div class="icon">
              <div class="iconfont icon-xuexiao xuexiao"></div>
            </div>
          </div>
          <div class="boxs">
            <div class="box">
              <div class="time">
                {{ item.member_info.member_education.start_time }} -
                {{ item.member_info.member_education.end_time }}
              </div>
              <div class="textBox c-1">
                <div class="text">
                  {{ item.member_info.member_education.school }}
                </div>
                <div class="yuan"></div>
                <div class="text">
                  {{ item.member_info.member_education.speciality }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="goutong">
        <div
          class="box dis-cent"
          @click.stop="messageClick(item.member_info.member_id)"
        >
          打招呼
        </div>
        <div
          class="csbox dis-cent"
          @click.stop="scClick(item.member_info.member_id, index)"
        >
          {{ item.member_info.is_favorite ? "取消收藏" : "收藏" }}
        </div>
        <div
          class="csbox dis-cent"
          @click.stop="dpClick(item.member_info.member_id)"
        >
          点评
        </div>
      </div>
    </div>
    <JobList :member_id="toId" v-if="jobShow" @show="jobShowJs" />
    <Jianli v-if="jlShow" :id="peoId" @show="jlShowJs" />
    <Dianping v-if="dianpingShow" @show="dpDelClick" :id="peoId" />
  </div>
</template>

<script>
import Dianping from "./dianping.vue";
import Jianli from "./jianli.vue";
import JobList from "./jobList.vue";

export default {
  components: {
    Dianping,
    Jianli,
    JobList,
  },
  name: "",
  data() {
    return {
      dianpingShow: false,
      peoId: "",
      jlShow: false,
      daysNum: 0,
      toId: 0,
      jobShow: false,
      glType: 0,
    };
  },
  props: ["list", "type"],
  watch: {
    list(val) {
      this.listGet(val);
    },
    type(val) {
      this.glType = val;
    },
  },
  created() {
    this.vipGet();
  },
  methods: {
    jobShowJs() {
      this.jobShow = false;
    },
    jump(id, i) {
      console.log(id);
      console.log(i);
      if (this.type == 1) {
        this.list[i].select = !this.list[i].select;
        this.$forceUpdate();
        let data = [];
        for (let i = 0; i < this.list.length; i++) {
          const e = this.list[i];
          if (e.select) {
            data.push({
              id: e.id,
              read_id: e.read_id,
              member_id: e.member_id,
            });
          }
        }
        this.$emit("delJs", data);
      } else {
        this.peoId = id;
        this.jlShow = true;
        this.stopScroll();
      }
    },
    jlShowJs() {
      this.jlShow = false;
      this.canScroll();
    },
    //禁止滚动
    stopScroll() {
      var mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", mo, false); //禁止页面滑动
    },
    /***取消滑动限制***/
    canScroll() {
      var mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = ""; //出现滚动条
      document.removeEventListener("touchmove", mo, false);
    },
    messageClick(id) {
      this.toId = id;
      this.jobShow = true;
      // this.$post("/chat/chat_begin", {
      //   id: id,
      //   job_id: this.jobId,
      //   user_type: 2,
      // }).then((res) => {
      //   // console.log(res);
      //   if (res.data.status == 1) {
      //     this.$router.push({
      //       path: "/gongsi/message",
      //       query: {
      //         id,
      //         job_id: this.jobId,
      //       },
      //     });
      //   } else {
      //     this.$message.error(res.data.msg);
      //   }
      // });
    },
    scClick(id, i) {
      this.$post("/nozzle/web/favorite_save", {
        id: id,
        genre: 3,
      }).then((res) => {
        console.log(res.data);
        if (res.data.status == 1) {
          this.list[i].member_info.is_favorite =
            !this.list[i].member_info.is_favorite;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    dpClick(id) {
      this.peoId = id;
      this.dianpingShow = true;
    },
    dpDelClick(id) {
      this.dianpingShow = false;
    },
    vipGet() {
      this.$get("/nozzle/web/company_vip").then((res) => {
        console.log(res);
        let startDate = this.$moment().format();
        let dateTimeStamp = this.$moment(res.vip.endtime * 1000).format();
        dateTimeStamp = this.$moment(dateTimeStamp);
        this.daysNum = dateTimeStamp.diff(startDate, "days");
      });
    },
    listGet(list) {
      const currentYear = new Date().getFullYear();
      for (let i = 0; i < list.length; i++) {
        const e = list[i];
        e.select = false;
        e.login_time = this.$moment(e.login_time).format("YYYY年M月D日");
        if (e.member_info.member_job) {
          let gxtime = this.$moment(e.member_info.refreshtime * 1000).format();
          gxtime = this.$moment(gxtime).format("YYYY年M月D日");
          e.gxtime = gxtime;
          e.member_info.member_job_txt = e.member_info.member_job
            .map((res) => res.intention_jobs)
            .join(",");
        } else {
          e.gxtime = "";
        }
        if (e.member_info.birthday) {
          e.age = currentYear - Number(e.member_info.birthday);
        }
      }
      this.list = list;
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.cont {
  cursor: pointer;
  width: 100%;
  border-radius: 5px;
  background-color: #fff;
  padding: 15px 20px;
  margin-bottom: 15px;
  display: flex;
  overflow: hidden;
  position: relative;
  .kuang {
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top-left-radius: 5px;
    border-bottom-right-radius: 5px;
    padding-left: 1px;
    box-sizing: border-box;
    cursor: pointer;
    border: 1px solid #c9c9c9;
  }
  .on {
    color: #e9e3e3;
    border: 1px solid #147ee0;
    background-color: #147ee0;
  }
  .close {
    position: absolute;
    top: 0;
    right: 0;
    width: 20px;
    height: 20px;
    display: none;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    background-color: rgba(0, 0, 0, 0.2);
    color: #fff;
    border-bottom-left-radius: 5px;
    padding-left: 1px;
    box-sizing: border-box;
    cursor: pointer;
  }
  .contLeft {
    width: 60px;

    .imgBox {
      width: 60px;

      .img {
        height: 60px;
        width: 60px;
        border-radius: 50%;

        img {
          border-radius: 50%;
        }
      }

      .money {
        width: 60px;
        height: 20px;
        border-radius: 20px;
        background-color: #f34e1c;
        color: #fff;
        margin-top: 10px;
        font-size: 12px;
        font-weight: 600;
      }
    }
  }

  .contRit {
    width: calc(45% - 60px);
    padding-left: 25px;
    box-sizing: border-box;
    padding-right: 25px;

    .name {
      font-weight: 500;
      font-size: 16px;

      span {
        font-weight: 400;
        font-size: 14px;
      }
    }

    .txtBox {
      display: flex;
      align-items: center;
      font-size: 12px;
      margin-top: 5px;

      .shu {
        width: 1px;
        height: 13px;
        background-color: #c9c9c9;
        margin: 0 8px;
      }

      .shu:last-child {
        display: none;
      }
    }

    .textBox {
      display: flex;
      align-items: center;
      font-size: 12px;
      margin-top: 5px;

      .txt {
        color: #999;
        width: 35px;
      }

      .txt1 {
        color: #999;
        margin-right: 7px;
      }

      .text {
        width: calc(100% - 35px);
      }

      .texts {
        display: flex;
        align-items: center;
        width: calc(100% - 35px);

        .yuan {
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background-color: #c9c9c9;
          margin: 0 6px;
        }
      }
    }

    .typeBox {
      display: flex;
      margin-top: 10px;

      .txt {
        padding: 3px 6px;
        background-color: #f0f3f7;
        margin-right: 10px;
        border-radius: 5px;
        color: #333;
        font-size: 12px;
      }
    }
  }

  .contJl {
    width: calc(55% - 80px);
    display: flex;
    flex-direction: column;
    justify-content: center;

    .lcLi {
      display: flex;
      width: 100%;
      font-size: 13px;

      .iconBox {
        width: 22px;
        display: flex;
        align-items: center;
        flex-direction: column;
        color: #b4b4b4;

        .icon {
          width: 16px;
          height: 20px;
          overflow: hidden;
        }

        .shu {
          border-left: 1px dashed #dadada;
          width: 1px;
          height: calc(100% - 20px);
        }

        .xuexiao {
          font-size: 19px;
          position: relative;
          top: -5px;
          left: -1px;
        }

        .liepinqiuzhi {
          font-size: 14px;
          position: relative;
          left: 1px;
        }
      }

      .boxs {
        width: calc(100% - 22px);

        .box {
          padding-left: 10px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          margin-bottom: 5px;

          .time {
            width: 130px;
            color: #9c9c9c;
          }

          .textBox {
            width: calc(100% - 130px);
            display: flex;
            align-items: center;

            .yuan {
              width: 5px;
              height: 5px;
              border-radius: 50%;
              background-color: #c9c9c9;
              margin: 0 10px;
            }
          }
        }
      }
    }
  }

  .goutong {
    width: 80px;

    .box {
      height: 40px;
      background-color: #147ee0;
      color: #fff;
      border-radius: 5px;
    }

    .csbox {
      background-color: #c90e0e;
      color: #fff;
      height: 40px;
      border-radius: 5px;
      margin-top: 10px;
    }
  }
}
.cont:hover {
  .close {
    display: flex;
  }
}
.anse {
  color: #999 !important;
}
</style>
